'use strict';
import * as _ from 'lodash';

import { module } from '../app';
import pubsubService from './pubsub.service';

module.service('signalrService', [
  'localStorage', '$timeout', '$interval', 'pingSvc', '$ionicLoading', '$rootScope', 'apiUrl', 'tpConfig',
  function (localStorage, $timeout, $interval, pingSvc, $ionicLoading, $rootScope, apiUrl, tpConfig) {
    let magViewUrlKey = 'MagViewUrl';
    let magViewAuthTokenKey = 'MagViewAuthToken';
    let magViewHospitalKey = 'hospital';
    let pingTimeout = 3000;
    let pingUrl = '/ping/ping.gif';

    let reconnectAttempt = 0;

    let instance = {
      worklist: $.connection.worklist,
      connect: firstConnect,
      disconnect: disconnect,
      isConnected: true,
      lastStatus: true,
      tryReconnectAgain: tryReconnectAgain
    };


    async function checkServerAccess() {
      let portalConnectionAvailable = false;

      let hospital = localStorage.getObject(magViewHospitalKey);
      if (!!localStorage.get(magViewUrlKey) && !!hospital) {
        await pingPortal();
      } else {
        portalConnectionAvailable = true;
        changeOnlineStatus(portalConnectionAvailable);
      }
    }

    async function pingPortal() {
      let portalConnectionAvailable = true;
      let internetAvailable = true;
      try {
        await pingSvc.ping(localStorage.get(magViewUrlKey));
        portalConnectionAvailable = true;
        internetAvailable = navigator.onLine;
      } catch (error) {
        portalConnectionAvailable = false;
        internetAvailable = navigator.onLine;
      } finally {
        changeOnlineStatus(portalConnectionAvailable, internetAvailable);
      }
    }

    function changeOnlineStatus(portalConnectionAvailable, internetAvailable) {
      $timeout(() => {

        instance.isConnected = portalConnectionAvailable;
        if (instance.lastStatus !== portalConnectionAvailable) {
          $rootScope.$broadcast(tpConfig.events.portalNetworkAvailabilityChanged, {
            isOnline: portalConnectionAvailable,
            internetAvailable: internetAvailable
          });
          if(instance.lastStatus == false)
            reconnect();
        }

        if (!localStorage.get(magViewUrlKey)) {
          instance.isConnected = true;
          if (reconnectAttempt > 0) {
            reconnectAttempt = 0;
            $ionicLoading.hide();
          }
          $timeout(checkServerAccess, pingTimeout);
          return;
        }

        if (portalConnectionAvailable === instance.lastStatus) {
          if (reconnectAttempt > 0) {
            reconnectAttempt = 0;
            $ionicLoading.hide();
          }
          $timeout(checkServerAccess, pingTimeout);
          return;
        }

        const ATTEMPTS_COUNT = 2;//7;
        if (!portalConnectionAvailable && reconnectAttempt < ATTEMPTS_COUNT) {

          if (reconnectAttempt === 0) {
            $ionicLoading.show({
              template: () => {
                return '<div class="loading-text">Reconnecting ...</div> <ion-spinner></ion-spinner>';
              }
            });
          }

          reconnectAttempt++;
          $timeout(checkServerAccess, pingTimeout);
          return;
        }


        if (reconnectAttempt === ATTEMPTS_COUNT || (reconnectAttempt > 0 && portalConnectionAvailable)) {
          if (reconnectAttempt === ATTEMPTS_COUNT) {
            $rootScope.$broadcast(tpConfig.events.givingUpReconnecting);
          }
          reconnectAttempt = 0;
          $ionicLoading.hide();
          instance.lastStatus = false;
          setTimeout(() => reconnect(), 5000);
        }

        instance.lastStatus = portalConnectionAvailable;
      });
    }

    async function tryReconnectAgain() {
      reconnectAttempt = 0;
      instance.lastStatus = null;
      await checkServerAccess();
      $timeout(checkServerAccess, pingTimeout);
    }

    function reconnect() {
      console.log('reconnect');
      $.connection.hub.start({
        jsonp: true,
      }).done(function(){
        if (!instance.lastStatus) {
          checkServerAccess();
        }
        $.connection.worklist.server.connect(localStorage.get(magViewAuthTokenKey));
        pubsubService.dispatch('SIGNALR_RECONNECT');
      });
    }

    function firstConnect() {
      console.log('firstConnect');
      $.connection.hub.url = _.trim(localStorage.get(magViewUrlKey), '/') + '/signalr';
      $.connection.worklist.client.start = function () {
      };

      $.connection.hub.start({
        jsonp: true,
      }).done(function () {
        $.connection.worklist.server.connect(localStorage.get(magViewAuthTokenKey));
      })
       .fail(function () {
         console.log('Connection failed. Retrying...');
         setTimeout(function () {
           reconnect();
         }, 3000);
       });

      $.connection.hub.error(function (error) {
        console.log('SignalR error: ' + error);
      });
      $.connection.hub.disconnected(() => {
        console.log('Connection closed. Retrying...');
        if (!localStorage.get(magViewUrlKey)) {
          return;
        }
        setTimeout(() => reconnect(), 3000);
      });
    }

    function disconnect() {
      console.log('disconnect');
      $.connection.hub.stop();
    }

    checkServerAccess();

    return instance;
  }
]);



// WEBPACK FOOTER //
// ./src/scripts/services/signalr.js